import { Box } from "@biom3/react";
import Image from "next/image";
import type React from "react";

interface AvatarProps {
  size?: number;
  imageUrl?: string;
  onClick?: () => void;
  className?: string;
  noRing?: boolean;
}

export const Avatar: React.FC<AvatarProps> = ({
  size = 72,
  imageUrl = "/images/profile/spaceman.png",
  onClick,
  className,
  noRing = false,
}) => {
  return (
    <Box
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        background: noRing ? "transparent" : "base.gradient.1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: noRing ? "0" : "3px",
        position: "relative",
        zIndex: 2,
        overflow: "hidden",
        cursor: "pointer",
      }}
      onClick={onClick}
      className={className}
      data-testid="avatar"
    >
      <Image
        src={imageUrl}
        alt="Profile"
        width={size}
        height={size}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%",
        }}
      />
    </Box>
  );
};
